import { render, staticRenderFns } from "./TemporaryManage.vue?vue&type=template&id=04d0c4fc&scoped=true&"
import script from "./TemporaryManage.vue?vue&type=script&lang=js&"
export * from "./TemporaryManage.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryManage.vue?vue&type=style&index=0&id=04d0c4fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d0c4fc",
  null
  
)

export default component.exports